import Icons from "../../../../utils/icons";

// Define the types for actions and icons
export const EMPLOYEE_ACTIONS = {
  Edit: "Edit",
  // View: "View",
} as const; // `as const` makes the object readonly and infers the types for each key

// Define the type for the action icons
export const EMPLOYEE_ACTIONS_ICONS: any = {
  View: Icons.RemoveRedEye,
  // Edit: Icons.Edit,
};

// Define the types for headers
type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  items?: { [key: string]: JSX.Element }; // Correct the items type to a record of JSX elements (icons)
  style?: React.CSSProperties;
  isNumeric?: boolean;
};

// Define the structure of the USER_HEADERS constant as an array directly
export const TEAM_HEADERS: Header[] = [
  {
    key: "teamname",
    label: "Team Name",
    sortable: true,
    style: { width: "15%" },
  },
  {
    key: "description",
    label: "Description",
    sortable: true,
    style: { width: "15%" },
  },
  {
    key: "teamhodname",
    label: "Team Leader",
    sortable: true,
    style: { width: "15%" },
  },
  {
    key: "teammembernames",
    label: "Team Members",
    sortable: true,
    style: { width: "15%" },
  },
  {
    key: "stakeholderentities",
    label: "Parties",
    sortable: true,
    style: { width: "15%" },
  },
  { key: "isActiveDetails", label: "Is Active?", style: { width: "8%" } },
  {
    key: "actions",
    label: "Action",
    style: { width: "8%" },
  },
];

export const BILLING_DASHBOARD_HEADERS: Header[] = [
  {
    key: "billingType",
    label: "Billing",
    style: { width: "10%", minWidth: "100px" },
    sortable: true,
  },
  {
    key: "billingFor",
    label: "Role / User",
    style: { width: "10%", minWidth: "150px" },
    sortable: true,
  },

  {
    key: "teamName",
    label: "Team Name",
    style: { width: "7%", minWidth: "150px" },
    sortable: true,
  },
  {
    key: "clientInformation",
    label: "Client Name",
    style: { width: "10%", minWidth: "150px" },
    sortable: true,
  },
  {
    key: "priority",
    label: "Priority",
    style: { width: "10%", minWidth: "120px" },
    sortable: true,
  },
  {
    key: "caseId",
    label: "Case ID",
    style: { width: "10%", minWidth: "200px" },
    sortable: true,
  },
  {
    key: "patientName",
    label: "Patient Name",
    style: { width: "10%", minWidth: "200px" },
    sortable: true,
  },
  {
    key: "accountNo",
    label: "Account No",
    style: { width: "10%", minWidth: "200px" },
    sortable: true,
  },
  {
    key: "caseExamTypes",
    label: "Case / Exam Type",
    style: {
      width: "10%",
      minWidth: "280px",
      maxWidth: "200px",
    },
    sortable: true,
  },

  {
    key: "rateType",
    label: "Rate Type",
    style: { width: "10%", minWidth: "120px", },
    sortable: true,
  },
  {
    key: "thresholdType",
    label: "Page / Line Threshold",
    style: { width: "10%", minWidth: "200px" },
    sortable: true,
  },
  {
    key: "currency",
    label: "Currency",
    style: { width: "10%", minWidth: "110px" },
    sortable: true,
  },
  {
    key: "rate",
    label: "Amount",
    style: { width: "10%", minWidth: "150px" },
    sortable: true,
  },

  {
    key: "effectiveFrom",
    label: "Effective From",
    style: { width: "20%", minWidth: "160px" },
    sortable: true,
  },
  {
    key: "effectiveTo",
    label: "Effective To",
    style: { width: "20%", minWidth: "170px" },
    sortable: true,
  },
  {
    key: "status",
    label: "Status",
    style: { width: "10%", minWidth: "120px" },
    sortable: true,
  },
  {
    key: "lastUpdatedOn",
    label: "Last Updated On",
    style: { width: "8%", minWidth: "160px" },
    sortable: true,
  },
  {
    key: "actions",
    label: "Action",
    style: { width: "8%", minWidth: "120px" },
  },
];

export const BILLING_SORT_KEY_MAP: Record<
  "SYSTEM" | "TEAM" | "CASE",
  Record<string, string>
> = {
  SYSTEM: {
    billingFor: "billingfor",
    priority: "priority",
    rateType: "ratetype",
    currency: "currency",
    rate: "rate",
    effectiveFrom: "effectivefrom",
    effectiveTo: "effectiveto",
    status: "status",
    lastUpdatedOn: "lastupdatedon",
  },

  TEAM: {
    billingType: "billingtype",
    billingFor: "billingforuserfullname",
    clientInformation: "clientinformation",
    teamName: "teamname",
    priority: "priorityname",
    caseExamTypes: "casetypenames",
    rateType: "ratetype",
    thresholdType: "thresholdtype",
    currency: "currencytype",
    rate: "rate",
    effectiveFrom: "effectivestartdate",
    effectiveTo: "effectiveenddate",
    status: "billingstatus",
    lastUpdatedOn: "modifieddate",
  },

  CASE: {
    caseInfoId: "caseinfoid",
    caseId: "caseid",
    billingFor: "billingforuserfullname",
    rateType: "ratetype",
    thresholdType: "thresholdtype",
    currency: "currencytype",
    lastUpdatedOn: "lastupdatedon",
    modifiedByName: "modifieddate",
  },
};

export const STANDARD_CHARGES_SORT_KEY_MAP: Record<string, string> = {
  standardChargeNote: "standardchargenote",
  priorityName: "priorityname",
  caseExamTypes: "caseexamtypes",
  currency: "currency",
  standardChargeRate: "standardchargerate",
  status: "status",
  lastUpdated: "lastupdatedon",
};

export const USER_MAPPING_LIST_HEADERS: Header[] = [
  {
    key: "primaryRoleDisplayName",
    label: "Primary User/Role",
    style: { width: "15%", minWidth: "170px" },
  },
  {
    key: "mappedRole",
    label: "Mapped Role",
    style: { width: "20%", minWidth: "170px" },
  },
  {
    key: "mappedUser",
    label: "Mapped User",
    style: { width: "20%", minWidth: "170px" },
  },
  {
    key: "userMappingUploadedOnBy",
    label: "Last Updated On | By",
    style: { width: "10%", minWidth: "170px" },
  },
  {
    key: "actions",
    label: "Action",
    style: { width: "5%", minWidth: "170px" },
  },
];

export const MAPPING_SUMMARY_HEADERS: Header[] = [
  {
    key: "primaryRole",
    label: "Primary Role",
  },
  {
    key: "qmeDoctor",
    label: "QME Doctor (PMC Staff)",
  },
  {
    key: "roleMapping",
    label: "Role Mapping",
  },
  {
    key: "userMapping",
    label: "User Mapping",
  },
];